import React from 'react';

class PriceOptions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: null,
    };
  }
  select(key, newProps) {
    this.setState({ selected: key });

    this.props.setPrice(newProps ? newProps.options[key] : this.props.options[key], key);
  }
  componentDidMount() {
    this.select(Object.keys(this.props.options)[0]);
  }
  componentDidUpdate() {
    // console.log('12');
    // this.select(Object.keys(this.props.options)[0]);
  }
  shouldComponentUpdate(props, state) {
    if (this.props.currency !== props.currency) {
      this.select(Object.keys(props.options)[0], props);
    }

    return true;
  }

  render() {
    var elements = [];

    for (let key in this.props.options) {
      elements.push(
        <div
          key={key}
          onClick={() => this.select(key)}
          className={
            'border rounded-5 mr-5 text-14 font-bold px-7 py-5 cursor-pointer price-' +
            parseInt(key) +
            ' ' +
            (this.state.selected == key ? 'bg-purple border-purple text-white' : 'border-black')
          }
        >
          {key} <span className="text-9 font-normal">sec</span>
        </div>
      );
    }

    return <div className="flex flex-row">{elements}</div>;
  }
}

export default PriceOptions;
